import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=153083db&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153083db",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('153083db')) {
      api.createRecord('153083db', component.options)
    } else {
      api.reload('153083db', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=153083db&scoped=true&", function () {
      api.rerender('153083db', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2aLBJLH68LJXx/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports